module.exports = __webpack_public_path__ + "static/img/9.151afb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/9.png
// module id = UPfe
// module chunks = 1